// SEO helpers shared across routes.
// Canonical domain is the production custom domain.
export const SITE_URL = "https://ranchplanner.com";
export const SITE_NAME = "RanchPlanner";
export const OG_IMAGE = `${SITE_URL}/og-cover.jpg`;

export function canonical(path: string): string {
  if (!path.startsWith("/")) path = "/" + path;
  return SITE_URL + (path === "/" ? "" : path);
}

export function buildSeoMeta(opts: {
  title: string;
  description: string;
  path: string;
  image?: string;
  type?: "website" | "article";
}) {
  const url = canonical(opts.path);
  const image = opts.image || OG_IMAGE;
  return {
    meta: [
      { title: opts.title },
      { name: "description", content: opts.description },
      { property: "og:type", content: opts.type || "website" },
      { property: "og:site_name", content: SITE_NAME },
      { property: "og:locale", content: "en_US" },
      { property: "og:url", content: url },
      { property: "og:title", content: opts.title },
      { property: "og:description", content: opts.description },
      { property: "og:image", content: image },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: opts.title },
      { name: "twitter:description", content: opts.description },
      { name: "twitter:image", content: image },
    ],
    links: [{ rel: "canonical", href: url }],
  };
}
